import { useBreakpointsUp } from '@app/core/hooks/useBreakpointsUp';
import { useMemo } from 'react';

/** Max broadcasts shown in the panorama strip: 1 in compact, 2 on LG, 3 on XL. */
export function useYoutubePanoramaVisibleCount(compact: boolean) {
  const { isLg, isXl } = useBreakpointsUp();

  return useMemo(() => {
    if (compact) {
      return 1;
    }

    if (isXl) {
      return 3;
    }

    if (isLg) {
      return 2;
    }

    return 2;
  }, [compact, isLg, isXl]);
}
